module.exports = __webpack_public_path__ + "img/fFishParad_193x205.a6493270.png";